import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { IUniqueIssuesFilterOptions } from '../services/queries/unique-issues-filters/helpers/transformResults';
import { getUniqueIssuesFilterOptions } from '../services/unique-issues-filters/UniqueIssuesFilterOptionsService';

export const useUniqueIssuesFilterOptions = (): UseQueryResult<IUniqueIssuesFilterOptions> => {
	return useQuery(
		['uniqueIssuesFilterOptions'],
		async (): Promise<IUniqueIssuesFilterOptions> => getUniqueIssuesFilterOptions(),
		{
			staleTime: 10 * 60 * 1000,
			cacheTime: 30 * 60 * 1000,
			refetchOnMount: true,
			refetchOnWindowFocus: false
		}
	);
};
